import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink, FormFeedback } from 'reactstrap';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

class Help extends Component {
  render() {
    	return (
      <div className="app align-items-center mcg">

        <span className="frontbk" style={{zIndex:"0"}} />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
            <Card className="mb-0">
            <Menu/>
              <CardHeader  className="titlehead">
                  <h1 className="mb-0 my-2">Help</h1>
                  <p className="text-center mb-0"></p>
              </CardHeader>
              <CardBody className="pageSetting login-form py-0">
                
                <Row>
                  <Col lg="12" className="leftbox pt-0">
                    
                    <div className="rb-inner" style={{ paddingTop: '2rem' }}>
                    <h1 className="mb-0 my-2">Compatible Phone List: VOCA V330 V530. Please make sure you have these phones before using our service.</h1>
                    <br />
                      <h1 className="mb-0 my-2">Register</h1>
<ol>
<li>In your internet browser, go to www.askmyphone.net</li>
<li>Click on the Register menu item (if you are on a mobile device, tap on the 3 lines in the upper left corner).</li>
<li>Enter your information using your desired email,your mobile phone number and a new password, Our system will check if your phone is valid for our service. If it is, our system will allow you to  press Register button.</li>
<li>You should then be on the Login screen, but if not, click on the Login menu item (if you are on a mobile device, tap on the 3 lines in the upper left corner).</li>
<li>Enter the login information that you used when you registered (email and password) then press Login button.</li>
<li>Once logged in you will be at the Settings page.</li>
<li>Enter any additional information, then press Save Changes</li>
</ol>
<br />
<h1 className="mb-0 my-2">Enable and Linking in the Alexa companion application</h1>
<ol>
<li>Open the Amazon Alexa app or Google Home application (either on your tablet / phone or for Amazon at alexa.amazon.com )</li>
<li>Tap on Skills menu item</li>
<li>Locate Ask My Phone in the skills list - easiest is to type Ask My Phone in the search area, then press the magnifying glass on the right.</li>
<li>Click on Enable Skill button on this page. The Ask My Phone Login page should display. </li>
<li>If it does not open, then Tap on the button that says Link Account (will be below a button that says Disable)</li>
</ol>
<br />
<h1 className="mb-0 my-2">I have registered but account says not linked</h1>
<ol>
<li>The following steps will reset the connection between Alexa and Ask My Phone:</li>
<li>From the Alexa app, disable the Ask My Phone skill.</li>
<li>Then enable the skill.</li>
<li>Normally, You would see a login screen but if you don't and instead see your account Settings information:</li>
<li>Then tap on the menu icon in that page (upper left corner) and click on Logout.</li>
<li>Then tap on X in upper right corner.</li>
<li>Then disable the skill and enable again to see the login screen.</li>
<li>Login in and you should get a message that says Account Linking successful.</li>
</ol>

                      {/*<div className="tips-msg pb-0">
                        For International Phone numbers (non U.S) please <NavLink href="#" className="inline-link">Click Here for Examples</NavLink>.<br /> 
                        Example showing UK: change this 07911 123456 to 447911123456
                      </div>*/}


                      <br />
                      <h1 className="mb-0 my-2">Contact</h1>
                      <div className="pb-0">Accounts may have up to 5 contacts. Each contact may have up to 3 contact methods:</div>
<ol>
<li>A phone number to receive a voice call from your phone. Could be a cell phone, or a traditional landline / home phone. 
</li>
<li>Click on the Register menu item (if you are on a mobile device, tap on the 3 lines in the upper left corner).</li>
<li>An email address for receiving email. This is used as a backup when your phone is powered off due to machine failure or low power. </li>
{/*Messages will be sent like, “Your friend is trying to contact you but his phone is down, please contact him”*/}
<li>A phone number where a text message (SMS) may be received. Commonly a cell phone.This is used as a backup when your phone is powered off due to machine failure or low power.</li>
{/*Messages will be sent like, “Your friend is trying to contact you but his phone is down, please contact him”*/}
</ol>
<br />
<div className="tips-msg pb-0">
                        Please be sure to confirm accuracy of the information, as the system cannot notify that the recipient information is incorrect.<br /> If more than one contact has the same first name, please provide a unique first name for each
                      </div>

                      <br />
                      <h1 className="mb-0 my-2">To Add a Contact</h1>
                      <ol>
                      <li>Enter contact information including First name, Last name, Cell number, Home (Voice) number, and/or Email address. </li>
                      <li>Press the Save Changes button at the bottom. </li>
                      </ol>

                       <br />
                      <h1 className="mb-0 my-2">To Delete a Contact</h1>
                      <ol>
                      <li>Go to the Contacts page, and mark the checkbox labeled Delete to the right of the contact to be removed then click the Save button. Please note that deletions cannot be undone.  </li>
                      <li>Press the Save Changes button at the bottom.</li>
                      </ol>

                      <br />
                      <h1 className="mb-0 my-2">Contact Names and Spelling</h1>
                      <div className="pb-0">If Ask My Phone is having difficulty with a specific contact name, Alexa may not be hearing the name, or Alexa is spelling what she hears differently than how it is entered in your Contacts list.
For example, your contact may be Kristie, but Alexa spells it Christy.  We do try to accommodate similar sounding names, but there are always some that do not quite match up.</div>
<div className="pb-0">In the Alexa application, on the Home page, you should see a 'card' that states what Alexa heard, please look to see what word Alexa heard and how she spells it.  
Try asking Alexa how to spell the names of your contacts, so you can see what Alexa hears.  Say, 'Alexa, how do you spell Lois?'  Then change the spelling in your contact list to be the same.  That way, Alexa will always get it right. </div>

<br />
                      <h1 className="mb-0 my-2">Trouble entering names</h1>
                      <div className="pb-0">Name entry errors can occur if it is not letters only, less than 2 characters, or Copy Paste was used to enter the name.</div>
<div className="pb-0">Avoid using copy and paste to fill in the fields. While not apparent to the eye, this can allow hidden characters to be included and possibly produce an error.  Refresh the webpage and try typing in the name again.</div>

<br />
                      <h1 className="mb-0 my-2">Are last names required to send an alert?</h1>
                      <div className="pb-0">No.  To send an alert, one needs to only say the first name of the desired contact.</div>

<br />
                      <h1 className="mb-0 my-2">Alerting/Calling Contacts</h1>
                      <div className="pb-0">To send Alerts, within voice range of Alexa, say one of the following examples: </div>
                      <table style={{border: "1px solid #dddddd"}}>
                      <tr>
                      <td style={{border: "1px solid #dddddd"}}>"Alexa, Ask My Phone to send Help"</td>
                      <td>This will activate the SOS button of your phone. It will sound an alarm, send SMS and then dial out to the contacts as pre-setted in the cell phone. Once the phone is connected, it will switch to speaker phone automatically. If your phone is down due to power failure, SMS and email will be sent to all your contacts as a backup measure.</td>
                      </tr><tr style={{border: "1px solid #dddddd"}}>
                      <td style={{border: "1px solid #dddddd"}}>"Alexa, Ask My Phone dial/contact/alert/call  Police/Ambulance/Fire Department/911/112/999/emergency/ Emergency Services/the Cops"</td>
                      <td>Alexa will send a command to your phone. On receiving this command, your phone will dial 911 or 999, depends on your country setting. Once the phone is connected, it will switch to speaker phone automatically.</td>
                      </tr><tr style={{border: "1px solid #dddddd"}}>
                      <td style={{border: "1px solid #dddddd"}}>"Alexa, Ask My Phone to dial/contact/alert/call XXXXX"</td>
                      <td>Alexa will send a command to your phone. On receiving this command, your phone will dial the number of XXXXX. Once the phone is connected, it will switch to speaker phone automatically.</td>
                      </tr><tr style={{border: "1px solid #dddddd"}}>
                      <td style={{border: "1px solid #dddddd"}}>"Alexa, Ask My Phone to answer"</td>
                      <td>On receiving this command, your phone will answer an incoming call</td>
                      </tr><tr style={{border: "1px solid #dddddd"}}>
                      <td style={{border: "1px solid #dddddd"}}>"Alexa, Ask My Phone to hangup"</td>
                      <td>On receiving this command, your phone will hang up an existing call</td>
                      </tr>
                      </table>

                      <br />
                      <h1 className="mb-0 my-2">I created a Contact but Alexa says the name is not found</h1>
                      <div className="pb-0">The Alexa interprets what it thinks you are saying then passes it along to our application. Let's say you have entered the first name of Pennie for your contact. When you say 'Alexa Ask My Phone To Alert Pennie', she responds with I'm sorry the name Pennie was not found in your contacts list. There can only be 3 reasons for this. </div>
                      <ol>
                      <li>There really isn't a contact with this name</li>
                      <li>Alexa passed a name with a different spelling</li>
                      <li>There was a significant amount of background noise or interference so the name was misunderstood.</li>
                      </ol>
                      <div className="pb-0">So how do we know which is the problem? Open the Alexa app on your phone and navigate to the Home page. The Home page should show you a Card with more detailed information as to why your contact wasn't found. Usually you will see that the spelling was different so you can either change the spelling for your contact name or change the name to a nickname like Mom or Sister.</div>
                      <div className="pb-0">You can still send Alerts by saying 'Alexa, Ask My Phone to send Help'</div>

                    </div>
                  </Col>
                  {/*
<Col lg="4" className="rightbox termsbox">
                    <div className="font-weight-bold stitle">Your Plan B Features are now active.</div>
                    <ol className="terms pb-4">
                      <li>120 Messages per month.</li>
                      <li>5 Additional Contacts have been added for a total of 10</li>
                      <li>Disable Alert All. This checkbox located at the bottom of the Settings Page, Use this if Alexa misunderstands you and defaults to Alert All. Send Help and Alert Everyone will still work.</li>
                      <li>Multi lingual Alerts: Spanish, French, Swedish, German, Portuguese and Italian. Need more, let us know. These language options can be selected from a drop down list for each contact you have entered on your Contact page.</li>
                    </ol>
                  </Col>
                  */}
                </Row>
              </CardBody>

            </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"3"}}>
          <CRNote/>
        </Container>
      </div>
    );
  }
}

export default Help;


// WEBPACK FOOTER //
// ./src/views/Pages/Help/Help.js